module.exports = __webpack_public_path__ + "Helvetica.6643d00df954eefc48f9.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/Helvetica.woff
// module id = ../../../../../src/app/@theme/fontes/Helvetica/Helvetica.woff
// module chunks = styles